import $ from 'jquery';

// Newsletter
function newsletter_footer() {
  $('#abonnement-newsletter').submit(function(e) {
    e.preventDefault();
    const email = $('#email_de_reception').val();
    if (email !== '') {
      $.ajax({
        type: 'POST',
        url: '/emploi/newsletter/create',
        data: JSON.stringify({ email: email }),
        contentType: 'application/json',
        dataType: 'json',
        success: function(data) {
          $('#email_de_reception')
            .prop('disabled', true)
            .addClass('disabled');
          $('#newsletter-message').remove();
          const newsletterMessage = $('.js-texte-newsletter');
          if (newsletterMessage.length) {
            // Si l'�l�ment existe (ex : nouvelle home)
            newsletterMessage.html(data.message).addClass('confirmation');
          } else {
            $('.inscription-newsletter').before(
              '<p id="newsletter-message" class="alert-box confirm" style="background-color: #d4f1bc;">' +
                data.message +
                '</p>'
            );
          }
          $('.js-footer-newsletter').html('Inscription valid&eacute;e !');
        },
        error: function(data) {
          $('#newsletter-message').remove();
          $('.inscription-newsletter').before(
            '<p id="newsletter-message" class="alert-box error" style="background-color: #ffcccc;">' +
              $.parseJSON(data.responseText).errors[0] +
              '<a href="" class="close" title="fermer">x</a>' +
              '</p>'
          );
        }
      });
    }
  });
}

export default newsletter_footer;
